import * as React from "react";
import Modal from "react-modal";
import { IconClose } from "themes";
import "./modal.less";
export interface IModalViewCartProps {
  isOpenModal: boolean;
  onCloseModal: () => void;
  okText?: string;
  cancelText?: string;
  onOk?: () => void;
  onCancel?: () => void;
  title?: | JSX.Element
  | JSX.Element[]
  | React.ReactChild
  | React.ReactChild[]
  | React.ReactNode;
  width?: number | string;
  height?: number | string;
  isModal?: boolean;
  isCustomizeFooter?: boolean;
  className?: string;
  portalClassName?: string;
  children?:
  | JSX.Element
  | JSX.Element[]
  | React.ReactChild
  | React.ReactChild[]
  | React.ReactNode;
  customizeFooterFixed?:
  | JSX.Element
  | JSX.Element[]
  | React.ReactChild
  | React.ReactChild[]
  | React.ReactNode;
}
Modal.setAppElement("#root");
export function ModalComponent(props: IModalViewCartProps) {
  const {
    okText,
    cancelText,
    onOk,
    onCancel,
    isOpenModal,
    onCloseModal,
    children,
    isModal,
    isCustomizeFooter,
    width,
    height,
    portalClassName,
    title,
    className,
    customizeFooterFixed,
  } = props;
  return (
    <React.Fragment>
      <Modal
        portalClassName={portalClassName}
        closeTimeoutMS={500}
        isOpen={isOpenModal}
        onRequestClose={onCloseModal}
        className={`shadow-2xl drop-shadow-2xl outline-none xl:w-3/5 mx-auto sm:w-full ${className}`}
        overlayClassName="Overlay"
        style={{
          content: {
            width: width,
            height: height,
          },
        }}
      >
        <div className={`modal-container rounded-2xl p-2`}>
          <div className="modal-react-header border-b py-2 flex justify-between content-center items-center">
            {title && (
              <h2 className="font-semibold text-md w-full text-center">
                {title}
              </h2>
            )}
            <div className="icon">
              <IconClose
                width={20}
                className="cursor-pointer "
                onClick={onCloseModal}
              />
            </div>
          </div>
          <div className="modal-react-content ">{children}</div>
          {!isCustomizeFooter && (
            <div className="space-x-2 text-center pt-5 mx-auto py-2 bottom-0 border-t  border-gray-300 modal-react-footer">
              <button
                onClick={onOk}
                className="btn--default px-8 transition-primary  uppercase btn--secondary hover:btn--secondary"
              >
                {okText ?? "Save"}
              </button>
              <button
                onClick={onCancel}
                className="btn--default px-8 transition-primary uppercase btn--primary"
              >
                {cancelText ?? "Cancel"}
              </button>
            </div>
          )}
        </div>
        {customizeFooterFixed && customizeFooterFixed}
      </Modal>

    </React.Fragment>
  );
}
